<template>
  <div class="settingContainer">
    <div id="formContainer">
      <el-form label-position="top" ref="formRef" :model="form">
        <el-form-item v-if="false" label="主题:">
          <el-select size="mini" v-model="form.theme" :placeholder="messageConfig.selectPlaceholder">
            <el-option v-for="i of ComBoxItems.theme" :key="i.name + ''" :label="i.name" :value="i.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认查看的问题:">
          <el-radio-group v-model="form.defaultSearch">
            <el-radio label="all">全部的</el-radio>
            <el-radio label="my">自己的</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="说明排序规则:">
          <el-radio-group v-model="form.explainSort">
            <el-radio label="desc">正序</el-radio>
            <el-radio label="asc">倒序</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="问题明细窗口是否只显示问题内容:">
          <el-radio-group v-model="form.ifShowQuestionDetail">
            <el-radio label="yes">是</el-radio>
            <el-radio label="no">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="说明显示风格:">
          <el-radio-group v-model="form.showDetailMode">
            <el-radio label="normal">旧版风格</el-radio>
            <el-radio label="timeLine">时间线显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="待办事项默认显示节点:">
          <el-radio-group v-model="form.todoDefaultShow">
            <el-radio label="我发起的">我发起的</el-radio>
            <el-radio label="全部">全部</el-radio>
            <el-radio label="未完成">未完成</el-radio>
            <el-radio label="已完成">已完成</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div id="buttonContainer">
      <el-button size="mini" @click="rollbackDefault">恢复默认</el-button>
      <el-button size="mini" type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.form = {
      ...this.form,
      ...JSON.parse(JSON.stringify(this.$store.state.systemSetting))
    }
  },
  data() {
    return {
      form: {
        theme: 'default',
        defaultSearch: 'all',
        explainSort: 'desc',
        ifShowQuestionDetail: 'no',
        // 待办事项默认查看类型
        todoDefaultShow: '未完成',
        showDetailMode: 'timeLine'
      },
      // 下拉框
      ComBoxItems: {
        theme: [
          { name: '默认(蓝色)', value: 'default' }
          // { name: '红色主题', value: 'red' },
          // { name: '粉色主题', value: 'pink' },
        ]
      }
    }
  },
  methods: {
    // 保存
    async save() {
      const that = this
      // 因为我这边所有选项都为必填 故不做校验
      const json = JSON.stringify(this.form)
      const { data: res } = await this.$http.put('/Common/YKUser/set-system-setting', {
        json
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      // Object.keys(this.form).forEach(key => {
      //   that.$emit('set_systemSettingByKey', key, this.form[key])
      //   console.log(this.form[key])
      // })
      that.$store.commit('set_systemSettingByObj', this.form)
    },
    // 恢复默认配置
    rollbackDefault() {
      this.form = {
        theme: 'default',
        defaultSearch: 'all',
        explainSort: 'desc',
        ifShowQuestionDetail: 'no',
        todoDefaultShow: '未完成',
        showDetailMode: 'timeLine'
      }
    }
  },
  watch: {
    systemSetting: {
      handler(newVal) {
        console.log(newVal)
      },
      deep: true
    }
  },
  computed: {
    systemSetting() {
      return this.$store.state.systemSetting
    }
  }
}
</script>
<style lang="less" scoped>
.settingContainer {
  height: 210px;
  border: 1px solid #f2f3f5;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 5px;
  #formContainer {
    box-sizing: border-box;
    height: 169px;
    overflow: auto;
    padding-bottom: 10px;
  }
  #buttonContainer {
    height: 30px;
    display: flex;
    justify-content: flex-end;
  }
}
.el-form-item {
  margin-bottom: 5px;
}
.el-radio {
  min-width: 80px;
}
.el-select {
  width: 70%;
}
/deep/ .el-form-item__label {
  height: 20px !important;
  line-height: 20px;
  padding: 0px !important;
}
/deep/ .el-form-item__content {
  height: 25px !important;
  line-height: 25px;
  box-sizing: border-box;
  padding-left: 30px;
}
</style>
